import Icon from '../components/Icon.vue'

Icon.register({"long-arrow-alt-up":{"width":256,"height":512,"paths":[{"d":"M88 166.1V468C88 474.6 93.4 480 100 480H156C162.6 480 168 474.6 168 468V166.1H214.1C235.4 166.1 246.1 140.2 231 125.1L145 39C135.6 29.7 120.4 29.7 111 39L25 125.1C9.9 140.2 20.6 166.1 41.9 166.1H88z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-alt-up.js
// module id = j+te
// module chunks = 0